import React from "react";
import { useTranslation } from "react-i18next";

const BenefitGroupStatusChanged = ({ notification }) => {
  const { t } = useTranslation();

  const benefitGroupName = notification?.payload?.benefitGroupName || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_benefit_group_status_changed_title", { benefitGroupName })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_benefit_group_status_changed_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_benefit_group_status_changed_description")}
      </p>
    </>
  );
};

export default BenefitGroupStatusChanged;
